import { render } from "./AIWizardPopupComponent.vue?vue&type=template&id=4bd2d48f&scoped=true"
import script from "./AIWizardPopupComponent.vue?vue&type=script&lang=js"
export * from "./AIWizardPopupComponent.vue?vue&type=script&lang=js"

import "./AIWizardPopupComponent.vue?vue&type=style&index=0&id=4bd2d48f&lang=css"
import "./AIWizardPopupComponent.vue?vue&type=style&index=1&id=4bd2d48f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bd2d48f"]])

export default __exports__